import { DOCUMENT_EXTENSIONS, DOCUMENT_REQUEST_LOCATION, IDocumentRequest } from "../../../models/utilities/document-request";
import { API_METHODS } from "../../../models/utilities/type-models";
import { ApiEndpoints } from "../../../utils/app-constants";
import { toCondensedDate } from "../../../utils/date-utils";
import { ShipmentType } from '../enums/_index';

export class DocumentRunLogExportBulk implements IDocumentRequest {

    public filename: string = '';
    public fileExtension: DOCUMENT_EXTENSIONS = 'xlsx';
    public openInTab: boolean = false;
    public url: string = '';
    public reportLocation: DOCUMENT_REQUEST_LOCATION = 'api';
    public methodType: API_METHODS = 'GET';

    constructor(shipmentIds: number[], routeType: ShipmentType) {

        let shipmentIdsStr = shipmentIds.reduce((accum: string, curr: number) => accum += curr + ',', '');
        shipmentIdsStr = shipmentIdsStr.substring(0, shipmentIdsStr.length - 1);

        this.url = ApiEndpoints.shipment(ApiEndpoints.TRANSPORTATION_ROUTE_BULK_RUNLOG_EXCEL_DOC, routeType).formattify(shipmentIdsStr);

        var displayId = shipmentIds.length === 1
            ? shipmentIds[0].toString()
            : toCondensedDate(new Date());

        this.filename = `${routeType === ShipmentType.Truck ? 'Truck' : 'Container'}_${displayId}_Runlog`;
    }

}
